import { Slider } from "@mui/material";
import { styled } from "@mui/material/styles";
import { getOpacity } from "@mui/material/styles/createColorScheme";

export const calculator = {
  header: "What's my monthly payment?",
  incomeBelow5k: "Income<br>RM3,000 - < RM5,000",
  incomeAbove5k: "Income<br>RM5,000 & above",
  financingAmountBelow5k: "Financing amount (min. RM10,000 - max. RM50,000)",
  financingAmountAbove5k: "Financing amount (min. RM5,000 - max. RM250,000)",
  insertAmountPlaceholder: "Insert amount required",
  tenureLabel: "Financing Tenure (in years)",
  monthlyPaymentLabel: "Your monthly installment (estimate)",
  calculateTotalButton: "Calculate",
  notes: (
    <>
      <span style={{ color: "#F04438" }}>*</span>The final financing amount,
      monthly financing payment, and profit rates are subject to the Bank's
      assessment and approval.
    </>
  ),
  amountErrorRequired: "Please enter an amount.",
  amountErrorRangeBelow5k:
    "Please enter an amount between RM10,000 and RM50,000.",
  amountErrorRangeAbove5k:
    "Please enter an amount between RM5,000 and RM250,000.",
};
export const calculatorMicroPfi = {
  header: "What's my monthly payment?",
  incomeBelow5k: "Financing Amount<br /> RM1,000 - RM10,000",
  incomeAbove5k: "Financing Amount<br /> RM10,500 - RM20,000",
  insertAmountPlaceholder: "Insert amount required",
  tenureLabel: "Financing Tenure (in years)",
  monthlyPaymentLabel: "Your monthly installment (estimate)",
  calculateTotalButton: "Calculate",
  notes: (
    <>
      <span style={{ color: "#F04438" }}>*</span>The final financing amount,
      monthly financing payment, and profit rates are subject to the Bank's
      assessment and approval.
    </>
  ),
  amountErrorRequired: "Please enter an amount.",
  amountErrorRangeBelow5k:
    "Please enter an amount between RM1,000 and RM10,000.",
  amountErrorRangeAbove5k:
    "Please enter an amount between RM10,500 and RM20,000.",
};

export const calculatorUmrah = {
  header: "Berapa bayaran bulanan saya?",
  incomeBelow5k: "Pendapatan<br>RM3,000 - < RM5,000",
  incomeAbove5k: "Pendapatan<br>RM5,000 & keatas",
  financingAmountBelow5k: "Jumlah pembiayaan (min. RM10,000 - max. RM50,000)",
  financingAmountAbove5k: "Jumlah pembiayaan (min. RM5,000 - max. RM250,000)",
  insertAmountPlaceholder: "Masukkan jumlah pembiayaan",
  tenureLabel: "Tempoh pembiayaan (tahun)",
  monthlyPaymentLabel: "Ansuran bulanan (anggaran)",
  calculateTotalButton: "Kira",
  notes: (
    <>
      <span style={{ color: "#F04438" }}>*</span>Amaun pembiayaan akhir, bayaran
      balik bulanan dan kadar keuntungan adalah tertakluk kepada penilaian dan
      kelulusan bank.
    </>
  ),
  amountErrorRequired: "Sila masukkan jumlah.",
  amountErrorRangeBelow5k: "Sila masukkan jumlah antara RM10,000 dan RM50,000.",
  amountErrorRangeAbove5k: "Sila masukkan jumlah antara RM5,000 dan RM250,000.",
};

export const calculatorCCSP = {
  header: "What's my monthly payment?",
  incomeBelow5k: "Income<br>RM3,500 - RM6,000",
  incomeAbove5k: "Income<br>RM6,001 & above",
  financingAmountBelow5k: "Financing amount (min. RM5,000 - max. RM80,000)",
  financingAmountAbove5k: "Financing amount (min. RM5,000 - max. RM250,000)",
  insertAmountPlaceholder: "Insert amount required",
  tenureLabel: "Financing Tenure (in years)",
  monthlyPaymentLabel: "Your monthly installment (estimate)",
  calculateTotalButton: "Calculate",
  notes: (
    <>
      <span style={{ color: "#F04438" }}>*</span>The final financing amount,
      monthly financing payment, and profit rates are subject to the Bank's
      assessment and approval.
    </>
  ),
  amountErrorRequired: "Please enter an amount.",
  amountErrorRangeBelow5k:
    "Please enter an amount between RM5,000 and RM80,000.",
  amountErrorRangeAbove5k:
    "Please enter an amount between RM5,000 and RM250,000.",
};

export const calculatorTD = {
  header: "What's my monthly payment?",
  incomeBelow5k: "Income RM3,000 - < RM5,000",
  incomeAbove5k: "Income RM5,000 & above",
  financingAmountBelow5k: "Financing amount (min. RM5,000 - max. RM500,000)",
  financingAmountAbove5k: "Financing amount (min. RM5,000 - max. RM250,000)",
  insertAmountPlaceholder: "Insert amount required",
  tenureLabel: "Financing Tenure (in years)",
  monthlyPaymentLabel: "Your monthly installment (estimate)",
  calculateTotalButton: "Calculate",
  notes: (
    <>
      <span style={{ color: "#F04438" }}>*</span>The final financing amount,
      monthly financing payment, and profit rates are subject to the Bank's
      assessment and approval.
    </>
  ),
  amountErrorRequired: "Please enter an amount.",
  amountErrorRangeBelow5k:
    "Please enter an amount between RM5,000 and RM500,000.",
  amountErrorRangeAbove5k:
    "Please enter an amount between RM5,000 and RM250,000.",
};

export const marks = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
];

export const CustomSlider = styled(Slider)(({ theme }) => ({
  color: "#221afb",
  height: 8,
  padding: "15px 0",
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "#221afb",
    border: "2px solid #221afb",
    "&:focus, &:hover, &.Mui-active": {},
  },
  "& .MuiSlider-track": {
    height: 8,
    borderRadius: 8,
  },
  "& .MuiSlider-rail": {
    height: 8,
    borderRadius: 8,
    backgroundColor: "#fff",
    boxShadow:
      "2px 2px 4px -2px rgba(24, 39, 75, 0.12) inset, 4px 4px 4px -2px rgba(24, 39, 75, 0.20) inset",
  },
  "& .MuiSlider-markLabel": {
    color: "#000045",
    fontSize: "14px",
  },
  "& .MuiSlider-mark": {
    display: "none",
  },
}));
